<template>
    <div>
        <template v-if="!loggedInDetail">
            <Customer />
        </template>
        <template v-else>
            <Agent :agentDetails="loggedInUserDetail"/>
        </template>
    </div>
</template>

<script>
import Customer from './CustomerForm.vue'
import Agent from './AgentForm.vue'

export default {
    name : 'CustomerRoot',
    components: {
        Customer,
        Agent
    },
    data(){
        return {
            loggedInDetail: null,
            loggedInUserDetail:null,
        }
    },
    mounted() {
        if(!this.$root.instance) {
          this.$router.push({ name: 'tour' })
        }
    },
    watch :{
        loggedInDetail: {
            handler(newVal, oldVal) {
                if (newVal.login_type === 'agent') {
                    this.fetchLoggedInUserDetails();
                }
            },
            deep: true,
            immediate: true
        }
    },
    created(){
        this.loggedInDetail = JSON.parse(localStorage.getItem('logged_in_user_credentials'))
    },
    methods: {
        fetchLoggedInUserDetails(){
            fetch(`${this.$root.$api}agent/user-detail`, {
                method: 'Post',
                body: JSON.stringify({
                    user_type: this.loggedInDetail.login_type,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.loggedInDetail.access_token
                }
            }).then(res => res.json())
            .then(response => {
                if (response.status) {
                    this.loggedInUserDetail = response.data
                }
            })
        }
    }        
}
</script>

<style lang="scss" scoped>

</style>